export const ACTIVE_MODE_STORAGE_KEY = "vouchee_active_mode";

export const getUserRoleFlags = (user) => {
  if (!user) {
    return { hasBusinessProfile: false, hasVoucheeProfile: false };
  }

  const accountType = String(user.account_type || "").toLowerCase();
  const legacyBusiness =
    accountType === "business_owner" ||
    accountType === "business" ||
    accountType === "admin" ||
    Boolean(user.business_id || user.businessId || user.business?.id);
  const legacyVouchee =
    accountType === "vouchee" ||
    accountType === "user" ||
    accountType === "admin";

  return {
    hasBusinessProfile: Boolean(user.has_business_profile || legacyBusiness),
    hasVoucheeProfile: Boolean(user.has_vouchee_profile || legacyVouchee),
  };
};

export const isAdminUser = (user) =>
  String(user?.account_type || "").toLowerCase() === "admin";

export const getStoredActiveMode = () => {
  if (typeof window === "undefined") return null;
  const mode = localStorage.getItem(ACTIVE_MODE_STORAGE_KEY);
  return mode === "business" || mode === "vouchee" ? mode : null;
};

export const setStoredActiveMode = (mode) => {
  if (typeof window === "undefined") return;
  if (mode === "business" || mode === "vouchee") {
    localStorage.setItem(ACTIVE_MODE_STORAGE_KEY, mode);
  }
};

export const resolveActiveMode = (user) => {
  const { hasBusinessProfile, hasVoucheeProfile } = getUserRoleFlags(user);

  if (hasBusinessProfile && hasVoucheeProfile) {
    return getStoredActiveMode() || "business";
  }

  if (hasBusinessProfile) return "business";
  return "vouchee";
};

export const resolveDashboardPath = (user) => {
  if (!user) return "/dashboard";
  if (isAdminUser(user)) return "/admin";
  return resolveActiveMode(user) === "business" ? "/business-dashboard" : "/dashboard";
};
